// extracted by mini-css-extract-plugin
export default {"bottom_container":"styles_bottom_container__hH7Ar"};